import { render } from "./price_filter.vue?vue&type=template&id=0277abb2"
import script from "./price_filter.vue?vue&type=script&lang=js"
export * from "./price_filter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__